'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const CONSUMERS_CHANNEL_SYMBOL = Symbol("CONSUMERS_CHANNEL_SYMBOL");

const channelMap = {};
const getChannelSingleton = _ref => {
  let {
    key
  } = _ref;
  if (!channelMap[key]) {
    channelMap[key] = new MessageChannel();
  }
  return channelMap[key];
};

const getChannel$2 = () => {
  const {
    port1: publicPort,
    port2: privatePort
  } = getChannelSingleton({
    key: CONSUMERS_CHANNEL_SYMBOL
  });
  return {
    publicPort,
    privatePort
  };
};

const IFRAME_CHANNEL_SYMBOL = Symbol("IFRAME_CHANNEL_SYMBOL");
const IFRAME_ID = "secure-script-container";

const getChannel$1 = () => {
  const {
    port1: localPort,
    port2: remotePort
  } = getChannelSingleton({
    key: IFRAME_CHANNEL_SYMBOL
  });
  return {
    localPort,
    remotePort
  };
};

const initialiseIFrameHandshake = _ref => {
  let {
    containerDomain
  } = _ref;
  const iframe = document.querySelector(`#${IFRAME_ID}`);
  if (!iframe) {
    throw new Error(`Could not find iframe with id "${IFRAME_ID}". Ensure the iframe is in the DOM by calling getIframeMarkup.`);
  }
  const {
    remotePort
  } = getChannel$1();
  const origin = `https://${containerDomain}`;
  const postMessage = () => iframe.contentWindow.postMessage(null, origin, [remotePort]);
  if (iframe.dataset.loaded === "true") {
    return postMessage();
  }
  iframe.addEventListener("load", () => postMessage(), {
    once: true
  });
};

const forwardMessages = () => {
  const {
    privatePort
  } = getChannel$2();
  const {
    localPort
  } = getChannel$1();
  privatePort.onmessage = _ref => {
    let {
      data
    } = _ref;
    return localPort.postMessage(data);
  };
};

const initialise = _ref => {
  let {
    containerDomain
  } = _ref;
  forwardMessages();
  initialiseIFrameHandshake({
    containerDomain
  });
};

const getChannel = () => {
  const {
    publicPort: port
  } = getChannel$2();
  return {
    port
  };
};

exports.getChannel = getChannel;
exports.initialise = initialise;
